import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shirt",
  "use": "shirt-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"shirt\"><defs><style>#shirt .cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px}</style></defs><path class=\"cls-1\" d=\"M246.74 86.53s49.26 12 87.34 45.59l-24.95 52.72-40.52-7v135.48H131.39V177.8l-40.52 7-25-52.72c38.13-33.55 87.39-45.55 87.39-45.55C156.2 113.42 170 136.1 200 136.1s43.8-22.68 46.74-49.57zM228.09 126.78l40.52 51.02M131.39 177.8l40.52-51.02\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol